export const ClientRoles = {
    user: "user",
    author: "author",
    reviewer: "reviewer"
  };
  